import { Flex, Text } from '@chakra-ui/react'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { usePhoneEndpoint } from '~/hooks/usePhone'
import { Size } from '~/types/ThemeTypes'

import { useNewExtensionSubscriptionModalStyle } from './componentStyles/NewExtensionSubscriptionModal.style'

export const NewExtensionSubscriptionModal = () => {
  const { t } = useTranslation()
  const [selectedExtensionIndex, setSelectedExtensionIndex] =
    useState<number>(0)

  const {
    extensionModal: [modalState, setModalState],
  } = useModalState()
  const {
    state: { extensions },
  } = usePhoneEndpoint({})
  const { pbxId } = useUserState()
  const {
    settings: {
      pbx: { extensions: trackedExtensions },
    },
    addTrackedExtension,
  } = useSettingsState(pbxId)

  const availableExtension = useMemo(() => {
    return extensions
      .filter(
        (ext) =>
          !trackedExtensions?.find((trackedExt) => trackedExt.id === ext.id),
      )
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [extensions, trackedExtensions])

  const selectedExtension = availableExtension[selectedExtensionIndex]

  const handleExtensionSelect = (id: number, index: number) => {
    setSelectedExtensionIndex(index)
  }

  const handleClose = () => {
    setModalState({ open: false })
    setSelectedExtensionIndex(0)
  }
  const handleSave = () => {
    addTrackedExtension({
      id: selectedExtension.id,
      name: selectedExtension.name,
      number: selectedExtension.number,
      uuid: selectedExtension.uuid,
    })
    handleClose()
  }

  const styles = useNewExtensionSubscriptionModalStyle()

  return (
    <MangoModal
      open={modalState.open}
      onOpenChange={(details) => {
        if (!details.open) handleClose()
      }}
      header={t('newExtensionSubscriptionModal.header')}
      body={
        <Flex css={styles.bodyContainer}>
          <Flex css={styles.dropdownContainer}>
            <Text css={styles.dropdownLabel}>
              {t('newExtensionSubscriptionModal.extension')}
            </Text>
            <DropdownSelect
              items={availableExtension.map((ext) => {
                return {
                  value: ext.id,
                  content: (
                    <Flex key={ext.id} css={styles.itemContainer}>
                      <Text css={styles.itemText}>{ext.name}</Text>
                      <ExtensionBadge size={Size.sm} extension={ext.number} />
                    </Flex>
                  ),
                  selectedLabel: `${ext.name} - ${ext.number}`,
                  searchLabel: `${ext.name} ${ext.number}`,
                }
              })}
              selectedIndex={selectedExtensionIndex}
              onSelect={handleExtensionSelect}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex css={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            {t('newExtensionSubscriptionModal.cancelButton')}
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            {t('newExtensionSubscriptionModal.saveButton')}
          </MangoButton>
        </Flex>
      }
    />
  )
}
